import React, { useState, useEffect } from 'react';
import { Button, Navbar, Dropdown } from 'react-daisyui';

const getSystemTheme = () =>
    window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const Header = () => {
    const [theme, setTheme] = useState(
        () => localStorage.getItem('theme') || getSystemTheme()
    );

    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme', theme);
    }, [theme]);

    // Follow system changes only when the user hasn't set a manual preference
    useEffect(() => {
        const mq = window.matchMedia('(prefers-color-scheme: dark)');
        const handler = (e) => {
            if (!localStorage.getItem('theme')) {
                setTheme(e.matches ? 'dark' : 'light');
            }
        };
        mq.addEventListener('change', handler);
        return () => mq.removeEventListener('change', handler);
    }, []);

    const toggleTheme = () => {
        setTheme(prev => (prev === 'light' ? 'dark' : 'light'));
    };

    return (
        <Navbar className="bg-base-100 shadow-sm sticky top-0 z-50">
            <Navbar.Start>
                <Dropdown>
                    <Button tag="label" color="ghost" tabIndex={0} className="lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h8m-8 6h16" />
                        </svg>
                    </Button>
                    <Dropdown.Menu tabIndex={0} className="w-52 menu-sm mt-3 z-[1]">
                        <Dropdown.Item>
                            <a href="#features">Features</a>
                        </Dropdown.Item>
                        <Dropdown.Item>
                            <a href="#screenshots">Screenshots</a>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <a href="/" className="btn btn-ghost normal-case text-xl gap-2">
                    <img src="/beanbag-app-logo.png" alt="Beanbag" className="w-8 h-8" />
                    <span className="font-bold">Beanbag</span>
                </a>
            </Navbar.Start>
            <Navbar.Center className="hidden lg:flex">
                <ul className="menu menu-horizontal px-1 gap-2">
                    <li><a href="#features" className="font-medium">Features</a></li>
                    <li><a href="#screenshots" className="font-medium">Screenshots</a></li>
                </ul>
            </Navbar.Center>
            <Navbar.End className="gap-2">
                <Button color="ghost" shape="circle" onClick={toggleTheme} aria-label="Toggle theme">
                    {theme === 'light' ? (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
                        </svg>
                    ) : (
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m8.66-9H21M3 12H2m15.07-6.07l-.71.71M7.64 17.36l-.71.71M17.36 17.36l-.71-.71M7.07 6.93l-.71-.71M12 5a7 7 0 100 14A7 7 0 0012 5z" />
                        </svg>
                    )}
                </Button>

            </Navbar.End>
        </Navbar>
    );
};

export default Header;
